// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce538a71","488":"a8a3d50d","553":"6c03e1bd","977":"37554e15"}[chunkId] + ".chunk.js";
};